export default __webpack_public_path__ + "static/media/BodyGame_15.3751710c.png";